module.exports = __webpack_public_path__ + "static/media/Barlow-Regular.9373fb66.ttf";